module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row home-row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1 left-column"
  }, [_c('div', {
    staticClass: "index-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.selectedParcours), function(parcours, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'parcoursIndex',
          params: {
            parcoursId: parcours.id_keyword
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                    " + _vm._s(_vm.versionLanguage(parcours.versions).title) + "\n                    "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 right-column"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.data
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fake-loader-container"
  }, [_c('div', {
    staticClass: "fake-loader-percentage"
  }, [_vm._v("0%")]), _vm._v(" "), _c('div', {
    staticClass: "fake-loader-bar-container"
  }, [_c('div', {
    staticClass: "fake-loader-bar"
  }, [_c('div', {
    staticClass: "fake-loader-bar-hide"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Anthologie"), _c('br'), _vm._v(" Palatine & découverte.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369d95b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeComponent.vue
// module id = 96
// module chunks = 0